import axios from "axios";

// Base API URL setup
const API_BASE_URL = process.env.REACT_APP_API_URL || "/api";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request Interceptor: Attach JWT Token based on target endpoint and current context
api.interceptors.request.use(
  (config) => {
    if (!config.headers["Authorization"]) {
      const url = config.url || "";
      const pathname = typeof window !== "undefined" ? window.location.pathname : "";

      const staffToken = localStorage.getItem("token");
      const computerToken =
        sessionStorage.getItem("computer_token") ||
        localStorage.getItem("computer_token");

      let token = null;

      // 1. Computer endpoints MUST always use computerToken
      if (url.startsWith("/computer")) {
        token = computerToken;
      }
      // 2. Staff management endpoints (shop, dealer, admin, reports, dashboard, etc.) MUST ALWAYS use staffToken
      else if (
        url.startsWith("/shop") ||
        url.startsWith("/dealer") ||
        url.startsWith("/admin") ||
        url.startsWith("/reports") ||
        url.startsWith("/dashboard") ||
        url.startsWith("/settings") ||
        url.startsWith("/wallet") ||
        url.startsWith("/upload")
      ) {
        token = staffToken;
      }
      // 3. Computer pages (/computer-dashboard, /fun-roulette, /computer-history) prefer computerToken
      else if (
        pathname.startsWith("/computer-dashboard") ||
        pathname.startsWith("/fun-roulette") ||
        pathname.startsWith("/computer-history")
      ) {
        token = computerToken || staffToken;
      }
      // 4. Default for all other pages (including /shops, /dashboard, /login, etc.): prefer staffToken
      else {
        token = staffToken || computerToken;
      }

      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor: Handle 401 Unauthorized (Auto Logout)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const pathname = typeof window !== "undefined" ? window.location.pathname : "";
      const isComputerContext =
        pathname.startsWith("/computer-dashboard") ||
        pathname.startsWith("/fun-roulette") ||
        pathname.startsWith("/computer-history") ||
        pathname.startsWith("/computer-login");

      if (isComputerContext) {
        sessionStorage.removeItem("computer_token");
        sessionStorage.removeItem("computer");
        localStorage.removeItem("computer_token");
        localStorage.removeItem("computer");

        if (pathname !== "/computer-login") {
          window.location.href = "/computer-login";
        }
      } else {
        localStorage.removeItem("token");
        localStorage.removeItem("user");

        if (pathname !== "/login") {
          window.location.href = "/login";
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;